import React from 'react';
import ResortCard from 'js/components/step1/ResortCard';
// import ResortFilter from 'js/components/step1/ResortFilter';
import DataService from 'js/modules/dataservice';
import daResorts from 'js/modules/resortData/index';
import FormGroup from 'react-nice-inputs/lib/FormGroup';
import Loader from 'js/components/global/Loader';

class ResortPicker extends React.Component {
  state = {
    readVacationPlanner: null,
    isDataReady: false,
    resorts: [],
    activities: [],
    questions: []
  }

  componentDidMount() {
    this._fetchData();
  }

  _fetchData = async() => {
    const readVacationPlanner = await DataService.readVacationPlanner();

    if (readVacationPlanner.code) {
      this.setState({ readVacationPlanner, isDataReady: true });
    }
  }

  filterResortDetails = (resortCode) => {
    const activities = [];
    const questions = [];
    const moods = [];
    let images;
    let reviews;

    if (this.state.isDataReady) {
      const { resortActivities, resortQuestions, resortMoods } = this.state.readVacationPlanner.content;

      resortActivities.forEach((activity) => {
        if (activity.resorts.includes(resortCode)) {
          activities.push(activity.activityName);
        }
      });

      resortQuestions.forEach((question) => {
        if (question.resorts.includes(resortCode)) {
          questions.push(question.questionText);
        }
      });

      Object.keys(resortMoods).forEach((mood) => {
        if (resortMoods[mood].includes(resortCode)) {
          moods.push(mood);
        }
      });

      images = this.state.readVacationPlanner.content.resortImages[resortCode];
      reviews = this.state.readVacationPlanner.content.resortReviews[resortCode];
    }

    return { activities, questions, images, reviews, moods };
  }

  populateResortFilter = () => {
    const { resortActivities, resortQuestions } = this.state.readVacationPlanner.content;

    const resorts = daResorts[window._app.brand].map((region, index) => {
      return { label: `${region.regionName} (${region.resortList.length}) Resort${region.resortList.length !== 1 ? 's' : ''}`, value: index };
    });

    const activities = resortActivities.map((activity, index) => {
      return { label: activity.activityName, value: index };
    });

    const questions = resortQuestions.map((question, index) => {
      return { label: question.questionText, value: index };
    });

    return { resorts, activities, questions };
  }

  handleFilterChange = (category) => (value) => {
    this.setState(() => {
      return { [category]: value.split(',').map(Number) };
    });
  }

  applyFilters = (regionName, questions, activities) => {
    if (this.state.isDataReady) {
      const { resortQuestions } = this.state.readVacationPlanner.content;
      const questionArray = resortQuestions.map((question) => question.questionText);
      const filteredQuestions = this.state.questions.map((index) => questionArray[index]);

      const regions = daResorts[window._app.brand].map((region) => region.regionName);

      const filteredResorts = this.state.resorts.map((index) => regions[index]);

      console.log(filteredQuestions);
      console.log(regionName, activities);
      console.log(filteredResorts);

      return questions.some((question) => filteredQuestions.includes(question)) || filteredResorts.includes(regionName);
    }

    return false;
  }

  render() {
    const resortList = daResorts[window._app.brand];

    if (!this.state.isDataReady) {
      return <Loader />;
    }

    return (
      <div className="resort-picker">
        <div className="resort-filter">
          <h3 className="filter-title">Filter resorts by...</h3>

          <h2 className="filter-heading no-border">BY RESORT LOCATION</h2>
          <FormGroup
            type="checkbox"
            name="resorts"
            onChange={this.handleFilterChange('resorts')}
            classList={['check-alt', 'filter-section']}
            options={this.populateResortFilter().resorts}
          />

          <h2 className="filter-heading">BY ACTIVITY</h2>
          <FormGroup
            type="checkbox"
            name="activities"
            onChange={this.handleFilterChange('activities')}
            classList={['check-alt', 'filter-section']}
            options={this.populateResortFilter().activities}
          />

          <h2 className="filter-heading">BY FEATURES</h2>
          <FormGroup
            type="checkbox"
            name="questions"
            onChange={this.handleFilterChange('questions')}
            classList={['check-alt', 'filter-section']}
            options={this.populateResortFilter().questions}
          />
        </div>

        <div className="resort-cards">
          {
            resortList.map((region) => {
              return region.resortList.map((resort) => {
                const resortCode = resort.value.toUpperCase();
                const { questions, activities, images, reviews } = this.filterResortDetails(resortCode);

                const filtered = this.applyFilters(region.regionName, questions, activities);

                const areFiltersEmpty = this.state.resorts.length === 0 && this.state.questions.length === 0 && this.state.activities.length === 0;

                return ((areFiltersEmpty || filtered) &&
                  <ResortCard
                    resort={resort}
                    questions={questions}
                    activities={activities}
                    images={images}
                    reviews={reviews}
                  />
                );
              });
            })
          }
        </div>
      </div>
    );
  }
}

export default ResortPicker;




// WEBPACK FOOTER //
// ./js/components/step1/ResortPicker.js